import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import Info from "../common/info";
import OptionForm from "./optionForm";

import { OptionFormContainer } from "../../styled/setting";
import { defaultOption } from "../../function/store";

const EditOption = ({ changeTab, selected, openModal, closeModal, getOptions, selectCompany }) => {
  const [option, setOption] = useState(defaultOption);

  useEffect(() => {
    if (selected) {
      setOption({
        ...selected,
        options: (selected?.options || []).map((opt) => ({
          ...opt,
          consumeCount: opt.consumeCount > 0 ? opt.consumeCount : 1,
        })),
      });
    }
  }, [selected]);

  const closeForm = () => {
    changeTab(0, null);
    setOption(defaultOption);
    closeModal();
  };

  const validationCheck = () => {
    if (!option.name) {
      toast.error("옵션그룹명을 입력해주세요.");
      return false;
    }
    if (!option.options?.length) {
      toast.error("옵션이 존재하지 않습니다.");
      return false;
    }

    for (let i = 0; i < option.options.length; i++) {
      const ele = option.options[i];
      const optionIndex = i + 1;

      if (!ele.value) {
        toast.error(`옵션 ${optionIndex}: 옵션명을 입력해주세요.`);
        return false;
      }
      if (ele.quantity === null || ele.quantity === undefined || ele.quantity === "") {
        toast.error(`옵션 ${optionIndex}: 수량을 입력해주세요.`);
        return false;
      }
      if (ele.addPrice === null || ele.addPrice === undefined) {
        toast.error(`옵션 ${optionIndex}: 가격을 입력해주세요.`);
        return false;
      }
    }

    return true;
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "옵션 그룹 수정",
      message: ["옵션 그룹을 수정하시겠습니까?"],
      handleConfirm: submitOption,
    });
  };

  const submitOption = async () => {
    const url = "/erp/optionGroup/update";

    const selectedIds = new Set(selected?.options?.map(({ id }) => id) || []);
    const currentIds = new Set(option.options?.map(({ id }) => id) || []);

    const formatOpt = ({ value, addPrice, quantity, status, consumeCount }) => ({
      value,
      addPrice: toNumber(addPrice),
      quantity: toNumber(quantity),
      consumeCount: toNumber(consumeCount),
      status,
    });

    const newOptions = option.options.filter(({ id }) => !selectedIds.has(id)).map(formatOpt);
    const options = option.options
      .filter(({ id }) => selectedIds.has(id))
      .map((opt) => ({ id: opt.id, ...formatOpt(opt) }));

    const body = {
      input: {
        cmpnyNo: selectCompany.value,
        id: option.id,
        name: option.name,
        isRequired: option.isRequired,
        status: option.status,
        codeName: option.codeName,
        options,
        newOptions,
        deleteOptionIds: [...selectedIds].filter((id) => !currentIds.has(id)),
      },
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("옵션 그룹이 수정되었습니다.");
        await getOptions();
        closeForm();
      }
    } catch (error) {
    } finally {
      closeModal();
    }
  };

  return (
    <OptionFormContainer>
      <Info
        message="옵션 그룹 수정"
        actions={[
          {
            label: "취소",
            func: () =>
              openModal({
                type: "confirmation",
                title: "나가기",
                message: ["작업 중인 내용이 사라질 수 있습니다.", "저장하지 않고 나가시겠습니까?"],
                handleConfirm: closeForm,
              }),
            key: "cancel",
          },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <OptionForm option={option} setOption={setOption} />
    </OptionFormContainer>
  );
};

export default EditOption;
